<template>
    <div class=" my">
        <nav-bar title="活动统计"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft"
                 class="my-nav">
        </nav-bar>
        <div style="margin-top: 2.9rem"></div>

        <div style="text-align: center">
               <ant-image v-for="(v,i) in list" :key="i"
                          fit="contain" style="margin: 1rem"
                          :src="v"/>
        </div>

    </div>
</template>

<script>
    import {Uploader, NavBar, CellGroup, Button, Toast, Image} from 'vant'
    import service from "../../api/service";
    //活动图片
    export default {
        name: "activityImg",
        components: {
            Uploader, NavBar, CellGroup, AntButton: Button, AntImage: Image
        },
        data() {
            return {
                id: '-',
                list: []
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity-creation-approval/img', {id: this.id}).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                    }
                })
            },
            //返回
            onClickLeft() {
                this.$router.push({path: this.$route.query.url})
            }
        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }

    .btn {
        margin: 1rem 0.5rem;
    }
</style>